import React, { useEffect, useState } from "react";
import { MDBCol, MDBContainer, MDBRow } from "mdb-react-ui-kit";
import axios from "axios";

import { validate } from "../../../components/login/validate";
// config
import configData from "../../../config/config.json";
// componets
import MetaTagsBusinessOwners from "../../../components/meta-tags-seo/MetaTagsBusinessOwners";
import Sidbarbusiness from "../../../components/business-dashboard/sidbar/Sidbarbusiness";
import HeaderMobile from "../../../components/business-dashboard/sidbar/HeaderMobile";
import AlertSuccess from "../../../components/AlertSuccess/AlertSuccess";
import AlertError from "../../../components/AlertError/AlertError";

const Business_tablighat = (props) => {
  const [render, setRender] = useState(false);

  const [data, setData] = useState({ email: "" });
  const [disable, setDisable] = useState(false);

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  useEffect(() => {
    setErrors(validate(data, "business-tablighat"));
  }, [data, touched]);

  const [errorAlert, setErrorAlert] = useState(null);
  const errorAlertHandeler = (lang) => {
    setErrorAlert(lang);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setErrorAlert(null);
    }, 4000);
  };

  const changeHandler = (e) => {
    var value = e.target.value;
    var result = value.replace(/[^A-Za-z\u0030-\u0039\s,@.]/g, "");

    setDisable(false);
    setData({ email: result });

    if (!/^[a-zA-Z0-9@.]*$/.test(e.target.value)) {
      errorAlertHandeler("انگلیسی");
    }
  };

  const [showAlert, setshowAlert] = useState(false);
  const alertHandeler = () => {
    setData({ email: "" });
    setshowAlert(true);
    setTimeout(() => {
      // After 3 seconds set the show value to false
      setshowAlert(false);
    }, 4000);
  };

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "business-ads",
    Authorization: "Bearer " + getCookie("token"),
  };

  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else if (render) {
      delete errors.email;

      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }
  }, [render]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  //api header
  const header = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    BizId: getCookie("BizId"),
    Authorization: "Bearer " + getCookie("token"),
  };

  const submitHandler = (event) => {
    event.preventDefault();

    if (data.email && !Object.keys(errors).length) {
      setDisable(true);

      const dataPost = {
        bId: getCookie("BizId"),
        email: data.email,
      };

      axios
        .post(configData.API_DOMAIN + "/api/v1/Advertisement", dataPost, {
          headers: header,
        })
        .then((response) => {
          setDisable(false);
          if (response.data.isSuccess) {
            // success
            delete errors.email;
            setTouched({
              email: false,
            });
            alertHandeler();
          }
        })
        .catch((error) => {
          alert(error);
        });
    } else {
      setTouched({
        email: true,
      });
    }
  };

  let windowWidth = "00";
  if (typeof window !== "undefined") {
    // Code that relies on the window object
    windowWidth = window.innerWidth;
  } else {
    windowWidth = "00";
  }
  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {windowWidth < 768 ? <HeaderMobile setRender={setRender} /> : ""}

      <div className="margin-0 d-flex bg_business_grey">
        <div className="  d-none d-md-block">
          {windowWidth > 767 ? <Sidbarbusiness setRender={setRender} /> : ""}
        </div>
        <MDBContainer className="bg_business_grey">
          <MDBRow>
            <MDBCol size="12">
              <div>
                <p className="text_img_bus">
                  تبلیغات <span className="d-none d-md-inline">در گیشنیز</span>
                </p>
              </div>
              <div className="container_tablighat_bus_content">
                <div className="c_text_img_bus_content">
                  برای اطلاع از نحوه تبلیغات در گیشنیز{" "}
                  <br className="d-sm-none" />
                  لطفا ایمیل خود را در کادر زیر وارد کنید.
                  <br />
                  در اسرع وقت پلن‌های تبلیغاتی را
                  <br className="d-sm-none" /> برای شما ارسال خواهیم کرد.
                </div>
                <div>
                  <input
                    value={data.email}
                    onChange={changeHandler}
                    type="email"
                    dir="ltr"
                    className={
                      errors.email && touched.email
                        ? "font-family-en bus-tabligh-input font-family-en border-error"
                        : "font-family-en bus-tabligh-input font-family-en"
                    }
                    placeholder="ایمیل"
                  />
                </div>
                {errors.email && touched.email && (
                  <span className="input-error mx-0 error-tablighat">
                    {errors.email}
                  </span>
                )}
                <div className="t_a_l_c">
                  <button
                    onClick={submitHandler}
                    disabled={disable}
                    className="btn_input_business"
                  >
                    ثبت
                  </button>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
      {/* alert delete */}
      <AlertSuccess
        showAlert={showAlert}
        text={" ایمیل شما با موفقیت ثبت شد."}
      />
      {/* alert error */}
      <AlertError
        showAlert={errorAlert}
        text={`زبان کیبورد را به ${errorAlert} تغییر دهید.`}
      />
    </>
  );
};

export default Business_tablighat;
